import EventsClass from './modules/events';
import WebshopkosarClass from './modules/webshopkosar';
import KostoloigenyloClass from './modules/kostoloigenylo';
import IrszaminputClass from './modules/irszaminput';
import GlscsomagpontClass from './modules/glscsomagpont';
import PostainfoClass from './modules/postainfo';


$(function () {
    // Modulok példányosítása
    const Webshopkosar = new WebshopkosarClass();
    const Irszaminput = new IrszaminputClass();
    const Kostoloigenylo = new KostoloigenyloClass();
    const Glscsomagpont = new GlscsomagpontClass();
    const Postainfo = new PostainfoClass();
    const Events = new EventsClass();

    window.Webshopkosar = Webshopkosar;
    window.kosar = Webshopkosar;
    window.Irszaminput = Irszaminput;
    window.Kostoloigenylo = Kostoloigenylo;
    window.Glscsomagpont = Glscsomagpont;
    window.Postainfo = Postainfo;
    window.Events = Events;

    // Események inicializálása
    Events.init();

    // GLS csomagpont inicializálása
    Glscsomagpont.init();

    // Posta info inicializálása (ha releváns az oldalon)
    if ($('.posta-valaszto').length > 0) {
        Postainfo.init();
    }

    // Kostoló igénylő inicializálása (ha releváns az oldalon)
    if ($('.kostololista-items').length > 0) {
        Kostoloigenylo.kostoloItemsSetEvents();
    }
});

